import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslator } from 'tradera/lang/translate';
import TranslateIcon from '@tradera/blueprint/theme/icons2/translate.svg?jsx';
import {
    selectHasTranslateableFeedbackItems,
    showError,
    showTranslatedReviews,
    selectIsTranslationOnDemandDisabled
} from 'tradera/state/views/profile/selectors';
import {
    hideTranslatedReviews,
    loadAndShowAllTranslatedReviews
} from 'tradera/state/views/profile/actions';

import { selectAutomaticTranslationPreferred } from 'tradera/state/language/selectors';
import { Button } from 'tradera/components/atoms/button/button';

const TranslateReviewsButton = ({
    showError,
    showTranslatedReviews,
    hideTranslatedReviews,
    loadAndShowAllTranslatedReviews,
    hasTranslateableFeedbackItems,
    isTranslationOnDemandDisabled,
    automaticTranslationPreferred
}) => {
    useEffect(() => {
        if (automaticTranslationPreferred) {
            loadAndShowAllTranslatedReviews();
        }
    }, [automaticTranslationPreferred, loadAndShowAllTranslatedReviews]);

    const { t } = useTranslator();
    return hasTranslateableFeedbackItems ? (
        <div className="my-2 d-flex align-items-center">
            <Button
                theme="action"
                variant="outline"
                className={`${showTranslatedReviews ? 'active' : ''}`}
                onClick={
                    showTranslatedReviews
                        ? hideTranslatedReviews
                        : loadAndShowAllTranslatedReviews
                }>
                {showTranslatedReviews ? (
                    <>
                        <span className="d-flex align-items-center justify-content-center">
                            <TranslateIcon className="icon mr-2" />
                            {t('profileRating_translateRevert')}
                        </span>
                    </>
                ) : (
                    <>
                        <TranslateIcon className="icon mr-2" />
                        {t('profileRating_translateAll')}
                    </>
                )}
            </Button>
            {isTranslationOnDemandDisabled && (
                <span className="ml-2">
                    <em>{t('profileRating_translationOnDemandDisabled')}</em>
                </span>
            )}
            {showError && (
                <span className="ml-2">
                    <em>{t('profileRating_translateError')}</em>
                </span>
            )}
        </div>
    ) : null;
};

const mapStateToProps = (state) => ({
    showError: showError(state),
    showTranslatedReviews: showTranslatedReviews(state),
    hasTranslateableFeedbackItems: selectHasTranslateableFeedbackItems(state),
    isTranslationOnDemandDisabled: selectIsTranslationOnDemandDisabled(state),
    automaticTranslationPreferred: selectAutomaticTranslationPreferred(state)
});

const mapDispatchToProps = {
    loadAndShowAllTranslatedReviews,
    hideTranslatedReviews
};

export const ConnectedTranslateReviewsButton = connect(
    mapStateToProps,
    mapDispatchToProps
)(TranslateReviewsButton);
